<template>
  <MessageContent />
</template>

<script lang="ts" setup>
import { HyperLink } from '#components'

type RichInboxMessageContentProps = {
  block?: boolean
  content: string
  maxChars?: number
}

const { block = false, content, maxChars } = defineProps<RichInboxMessageContentProps>()

const paragraphs = computed(() => parseMarkdown(content))

const inlineNodes = computed(() => {
  const flat = flattenToInline(paragraphs.value)
  return maxChars === undefined ? flat : truncateInline(flat, maxChars)
})

const renderNodes = (nodes: MdInlineNode[]): (string | VNode)[] =>
  nodes.map((node) => {
    if (node.type === 'text') {
      return node.value
    }
    if (node.type === 'bold') {
      return h('strong', renderNodes(node.children))
    }
    if (node.type === 'sup') {
      return h('sup', renderNodes(node.children))
    }

    return h(
      HyperLink,
      {
        class: 'text-link',
        onClick: withModifiers(() => {}, ['stop']),
        to: node.url,
      },
      () => renderNodes(node.children),
    )
  })

const MessageContent = computed(
  () => () =>
    block
      ? h(
          'div',
          paragraphs.value.map((paragraph, index) =>
            h('p', { class: 'message-paragraph', key: index }, renderNodes(paragraph.children)),
          ),
        )
      : h('span', renderNodes(inlineNodes.value)),
)
</script>
